import { gql } from 'graphql-request'

export const GET_USER_LIVE_SETTING = gql`
  query GET_USER_LIVE_SETTING($liveId: Int!) {
    getUserLiveSetting(liveId: $liveId) {
      status
      error
      data {
        id
        liveId
        playSoundEffects
        playAllSpecialEffectEntrance
        playAllSpecialEffectGift
        playAllSpecialEffectLuckGift
        playModeRecordGift
        playNotificationGiftSentPushCountry
        playNotificationGiftSentPushLive
      }
    }
  }
`
